/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minimum_Quantity_PlaceholderInputs */

const en_minimum_quantity_placeholder = /** @type {(inputs: Minimum_Quantity_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min qty`)
};

const es_minimum_quantity_placeholder = /** @type {(inputs: Minimum_Quantity_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cant. min`)
};

/**
* | output |
* | --- |
* | "Min qty" |
*
* @param {Minimum_Quantity_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const minimum_quantity_placeholder = /** @type {((inputs?: Minimum_Quantity_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minimum_Quantity_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minimum_quantity_placeholder(inputs)
	return es_minimum_quantity_placeholder(inputs)
});